module.exports = __webpack_public_path__ + "static/media/adsk-projects working.008cafea.txt";